// Module
var code = "<article class=\"sw-scroll-top\" ng-click=\"$ctrl.scrollTop()\" ng-class=\"{ 'sw-scroll-top--active': $ctrl.isScrolling }\"> <i class=\"fa fa-arrow-alt-up\"></i> <sw-font-awesome icon=\"$ctrl.faArrowAltUp\"></sw-font-awesome> </article> ";
// Exports
export default code;